import React from 'react';
import tw from 'twin.macro';

const fontColors = {
  default: tw`text-default`,
  primary: tw`text-primary`,
  input: tw`text-input-front`,
  'input-back': tw`text-input-back`,
  icons: tw`text-icons`,
  success: tw`text-success`,
  warning: tw`text-warning`,
  danger: tw`text-danger`,
  brand: tw`text-brand`,
  dark: tw`text-dark`,
  light: tw`text-light`,
};

const iconRotation = {
  minus90: tw`-rotate-90`,
  90: tw`rotate-90`,
  180: tw`rotate-180`,
};

const iconSizes = {
  small: tw`w-3 h-3`,
  medium: tw`w-5 h-5`,
  base: tw`w-7 h-7`,
  large: tw`w-12 h-12`,
  xlarge: tw`w-20 h-20`,
};

export const Icon = ({
  Type,
  animate,
  size = 'base',
  color = 'icons',
  rotation = '',
  ...restProps
}) => {
  return (
    <Type
      css={[
        fontColors[color],
        iconSizes[size],
        iconRotation[rotation],
        animate && tw`transition-all duration-300 ease-in-out`,
      ]}
      {...restProps}
    />
  );
};
